/** Map Supabase profile row → legacy frontend user shape */
export function mapProfile(row) {
  if (!row) return null;
  const prefs = row.preferences ?? {};
  // Handles Postgres rows, profile_to_json JSONB, and legacy camelCase
  return {
    id: row.id,
    firstName: row.first_name ?? row.firstName ?? "",
    lastName: row.last_name ?? row.lastName ?? "",
    email: row.email ?? "",
    bio: row.bio ?? "",
    country: row.country ?? "",
    education: row.education ?? "",
    birthDate: row.birth_date ?? row.birthDate ?? null,
    profileImageUri: row.profile_image_uri ?? row.profileImageUri ?? null,
    isProfileComplete: row.is_profile_complete ?? row.isProfileComplete ?? false,
    isVerified: row.is_verified ?? row.isVerified ?? false,
    isActive: row.is_active ?? row.isActive ?? true,
    role: row.role ?? "user",
    stripeCustomerId: row.stripe_customer_id ?? row.stripeCustomerId ?? null,
    stripeSubscriptionId: row.stripe_subscription_id ?? row.stripeSubscriptionId ?? null,
    subscriptionActive: row.subscription_active ?? row.subscriptionActive ?? false,
    subscriptionSource: row.subscription_source ?? row.subscriptionSource ?? "stripe",
    premiumUntil: row.premium_until ?? row.premiumUntil ?? null,
    termsAcceptedAt: row.terms_accepted_at ?? row.termsAcceptedAt ?? null,
    ageAttestedAt: row.age_attested_at ?? row.ageAttestedAt ?? null,
    termsVersion: row.terms_version ?? row.termsVersion ?? null,
    latitude: row.latitude ?? null,
    longitude: row.longitude ?? null,
    createdAt: row.created_at ?? row.createdAt ?? null,
    updatedAt: row.updated_at ?? row.updatedAt ?? null,
    preferences: prefs,
    gender: prefs.gender ?? row.gender ?? "",
    occupation: prefs.occupation ?? row.occupation ?? "",
    drinking: prefs.drinking ?? row.drinking ?? "",
    smoking: prefs.smoking ?? row.smoking ?? "",
    workout: prefs.workout ?? row.workout ?? "",
    religion: prefs.religion ?? row.religion ?? "",
    age: prefs.age ?? row.age ?? null,
  };
}

/** Normalize Azure-style PascalCase payloads and camelCase into Supabase fields */
export function normalizeUserPayload(data) {
  const userId = data.userId ?? data.id ?? data.Id;
  const lifestyle = {
    gender: data.gender ?? data.Gender ?? undefined,
    occupation: data.occupation ?? data.Occupation ?? undefined,
    drinking: data.drinking ?? data.Drinking ?? undefined,
    smoking: data.smoking ?? data.Smoking ?? undefined,
    workout: data.workout ?? data.Workout ?? undefined,
    religion: data.religion ?? data.Religion ?? undefined,
    age: data.age ?? data.Age ?? undefined,
  };
  Object.keys(lifestyle).forEach((k) => lifestyle[k] === undefined && delete lifestyle[k]);

  return {
    userId,
    email: data.email ?? data.Email,
    firstName: data.firstName ?? data.FirstName,
    lastName: data.lastName ?? data.LastName,
    bio: data.bio ?? data.Bio,
    country: data.country ?? data.Country,
    education: data.education ?? data.Education,
    birthDate: data.birthDate ?? data.birth_date ?? data.BirthDate ?? null,
    profileImageUri: data.profileImageUri ?? data.ProfileImageUri,
    isProfileComplete: data.isProfileComplete ?? data.IsProfileComplete,
    isVerified: data.isVerified ?? data.IsVerified,
    termsAcceptedAt: data.termsAcceptedAt ?? data.terms_accepted_at ?? null,
    ageAttestedAt: data.ageAttestedAt ?? data.age_attested_at ?? null,
    termsVersion: data.termsVersion ?? data.terms_version ?? null,
    lifestyle,
  };
}

export function mapProfileToDb(user) {
  if (!user) return {};
  return {
    id: user.id,
    email: user.email,
    first_name: user.firstName,
    last_name: user.lastName,
    bio: user.bio,
    country: user.country,
    education: user.education,
    birth_date: user.birthDate || null,
    profile_image_uri: user.profileImageUri,
    is_profile_complete: user.isProfileComplete ?? user.is_profile_complete ?? false,
    is_verified: user.isVerified ?? user.is_verified ?? false,
    is_active: user.isActive ?? user.is_active ?? true,
    stripe_customer_id: user.stripeCustomerId ?? user.stripe_customer_id,
    stripe_subscription_id: user.stripeSubscriptionId ?? user.stripe_subscription_id,
    subscription_active: user.subscriptionActive ?? user.subscription_active ?? false,
    terms_accepted_at: user.termsAcceptedAt ?? user.terms_accepted_at ?? null,
    age_attested_at: user.ageAttestedAt ?? user.age_attested_at ?? null,
    terms_version: user.termsVersion ?? user.terms_version ?? null,
    latitude: user.latitude,
    longitude: user.longitude,
    preferences: user.preferences ?? {},
  };
}

export function mapImageRow(row) {
  return {
    id: row.id,
    fileName: row.file_name ?? row.fileName,
    storagePath: row.storage_path ?? row.storagePath,
  };
}
